import React, { ReactNode } from 'react';
import { Component } from '../../../concepts/objects';
import { AnimateHack } from './AnimateHack';
import { PoseAttr } from './Pose';
import { RenderingContext } from './RenderingContext';

export abstract class VisualBase<T extends Component> extends React.Component<{ object: T, children?: ReactNode }> {

    public static contextType = RenderingContext;

    protected get lgfx() {
        return (this.context as any).gfxLevel < 2;
    }

    protected get pose() {
        return PoseAttr.get(this.object);
    }

    protected get interaction() {
        return this.pose.interaction;
    }

    protected get object() {
        return this.props.object;
    }

    protected get isRoot() {
        return !!this.pose.isRoot;
    }

    protected get isBeingEdited() {
        return !!this.pose.beingEdited;
    }

    protected get isBeingManipulated() {
        return !!this.pose.beingManipulated;
    }

    protected get isHighlighted() {
        const d = this.pose;
        return !!(d.pressed || d.targeted || d.selected) && !d.isRoot && !d.beingManipulated;
    }

    protected get isPressed() {
        return !!this.pose.pressed;
    }

    protected get isSelected() {
        return this.pose.selected;
    }

    protected get isMultiSelected() {
        return this.pose.selected && this.pose.peers;
    }

    protected get hasEffects() {
        return !!this.pose.effects && !!Object.keys(this.pose.effects).length;
    }

    protected shouldAnimate(_object?: Component) {
        // Holy moly...
        return AnimateHack.animate;
    }
}
